import { useState } from "react";

import { ValidationError, ObjectSchema } from "yup";
import { ObjectShape } from "yup/lib/object";

import { Branch } from "../../../../../../../models/branch";
import { Status } from "../../../../../../../util/enums";

export enum Tabs {
  BRANCH = "branch",
  CONTACTS = "contacts",
}

export const useBranchAction = () => {
  const [branch, setBranch] = useState<Branch>();
  const [errors, setErrors] = useState<ValidationError[]>([]);
  const [options, setOptions] = useState<string[]>([Tabs.BRANCH]);
  const [currentStep, setCurrentStep] = useState<string>(Tabs.BRANCH);
  const [selectedLeftPanel, setSelectedLeftPanel] = useState<number>(0);

  const handleUpdateBranch = (branch?: Branch) => {
    let branchToUpdate = branch;

    if (branchToUpdate && !branchToUpdate.status)
      branchToUpdate = { ...branch, status: Status.INACTIVE };
    setBranch((state) => (state ? { ...state, ...branchToUpdate } : { ...branchToUpdate }));
  };

  const handleClearFields = () => setBranch({ status: Status.INACTIVE });

  const handleValidateSchemaSuccess = (schema: ObjectSchema<ObjectShape>): boolean => {
    schema.validateSync(
      {
        code: branch?.code,
        name: branch?.name,
        description: branch?.description,
        isValidateContact: currentStep === Tabs.CONTACTS || !!branch?.id,
        contacts: branch?.contacts,
      },
      { abortEarly: false }
    );
    setErrors([]);

    return true;
  };

  const handleValidateSchemaError = (error: ValidationError): boolean => {
    if (error) {
      setErrors(error.inner);
    }

    return false;
  };

  const handleValidate = (schema: ObjectSchema<ObjectShape>): boolean => {
    try {
      return handleValidateSchemaSuccess(schema);
    } catch (error) {
      if (error instanceof ValidationError) return handleValidateSchemaError(error);

      return false;
    }
  };

  const nextStep = (step: string) => {
    if (!options.includes(step)) setOptions((state) => (state ? [...state, step] : [step]));
    setCurrentStep(step);
  };

  const previousStep = (nextOptions: string[], nextStep: string) => {
    setOptions([...nextOptions]);
    setCurrentStep(nextStep);
  };

  return {
    branch,
    errors,
    options,
    currentStep,
    selectedLeftPanel,
    setSelectedLeftPanel,
    handleClearFields,
    handleUpdateBranch,
    handleValidate,
    nextStep,
    previousStep,
  };
};
